import React, { useState, useEffect } from 'react';
import { Button } from '../../common/buttons';
import { useSelector } from 'react-redux';
import { getMap, rotateTo, getPitch, getBearing, getZoom, getCenter } from '../../interface/';
import { Icon, SVGIcon } from '../../common/layout';

import ZoomControl from './ZoomControl/ZoomControl';

import panDown from '../../../assets/pandown.svg';
import panUp from '../../../assets/topview.svg';
import compass from '../../../assets/compass.svg';

import './MapControls.scss';
import Overlays from './Overlays/Overlays';

const MapControls = () => {
  const [pitchUp, setPitchUp] = useState(true);
  const [currentZoom, setCurrentZoom] = useState(17);
  const [rotation, setRotation] = useState(90);
  const { default_view } = useSelector((state) => state.settings);
  const view = default_view;
  const map = getMap();

  useEffect(() => {
    const setPitchAndBearing = () => {
      const pitch = getPitch();
      const zoom = getZoom();
      setPitchUp(!(pitch > 0));
      setRotation(map.camera.getState().bearing);
      setCurrentZoom(zoom);
    };
    if (!map) {
      return undefined;
    }
    setPitchAndBearing();
    return map.on('move', setPitchAndBearing);
  }, [map]);

  const rotate90 = () => {
    const center = getCenter();
    rotateTo({
      pitch: getPitch(),
      bearing: getBearing() - 90,
      zoom: getZoom(),
      lat: center.lat,
      lng: center.lng,
    });
  };

  const setPitch = () => {
    const center = getCenter();
    const options = {
      bearing: getBearing(),
      zoom: getZoom(),
      lat: center.lat,
      lng: center.lng,
    };
    if (getPitch() > 0) {
      rotateTo({ ...options, pitch: 0 });
    } else {
      rotateTo({ ...options, pitch: 60 });
    }
  };

  const rotateNorth = () => {
    const center = getCenter();
    rotateTo({
      pitch: getPitch(),
      bearing: 0,
      zoom: getZoom(),
      lat: center.lat,
      lng: center.lng,
    });
  };

  return (
    <div className="map-controls">
      <Button
        className="map-controls__reset-view-btn map-btn"
        handleClick={() => rotateTo(view)}
        aria-label="Reset View"
        toolTipId="reset-view-btn"
        renderToolTip={() => <p>Reset View</p>}
      >
        <Icon iconName="home" />
      </Button>
      <Overlays />
      <Button
        className="map-controls__rotate-btn map-btn"
        handleClick={rotate90}
        aria-label="Rotate"
        toolTipId="rotate-90-btn"
        renderToolTip={() => <p>Rotate 90 Degrees</p>}
      >
        <Icon iconName="refresh" />
      </Button>
      <Button
        className="map-controls__pitch-btn map-btn"
        handleClick={setPitch}
        aria-label={pitchUp ? 'Set Pitch Down' : 'Set Pitch Up'}
        toolTipId="set-pitch-btn"
        renderToolTip={() => (
          <p>{pitchUp ? 'Set Pitch Down' : 'Set Pitch Up'}</p>
        )}
      >
        <SVGIcon svg={pitchUp ? panUp : panDown} />
      </Button>
      <ZoomControl zoom={currentZoom} />
      <Button
        className="map-controls__zoom-out-btn map-btn"
        handleClick={rotateNorth}
        aria-label="Set North"
        toolTipId="compass-btn"
        renderToolTip={() => <p>View North</p>}
      >
        <SVGIcon
          svg={compass}
          style={{ transform: `rotate(${-rotation}deg)` }}
        />
      </Button>
    </div>
  );
};

export default MapControls;
